import { BrowserRouter as Router } from 'react-router-dom';
import { AppProvider } from './providers/AppProvider';
import { Toaster } from '@/components/ui/sonner';
import { AppRoutes } from './AppRoutes';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { ExitIntentModal } from './components/ExitIntentModal';
import { useExitIntent } from './hooks/useExitIntent';
import { useAuth } from './contexts/AuthContext';

import { HelmetProvider } from 'react-helmet-async';

const paypalOptions = {
  clientId: import.meta.env.VITE_PAYPAL_CLIENT_ID || "demo",
  currency: "EUR",
  intent: "capture",
  // Vereinfachte Konfiguration für Einmalkäufe
  components: "buttons"
};

const isPayPalConfigured = () => {
  const clientId = import.meta.env.VITE_PAYPAL_CLIENT_ID;
  return !!(clientId && clientId !== "demo" && clientId.length > 50);
};

function AppContent() {
  const { user } = useAuth();
  const { showExitIntent, hideExitIntent } = useExitIntent({
    enabled: !user, // Nur für nicht-angemeldete Nutzer aktivieren
    delay: 3000, // 3 Sekunden warten bevor Exit-Intent aktiviert wird
    sensitivity: 30 // 30 Pixel vom oberen Rand
  });

  return (
    <HelmetProvider>
      <Router>
        <AppProvider>
          <AppRoutes />
          <Toaster />
          {/* ExitIntentModal nur für nicht-angemeldete Nutzer */}
          {!user && (
            <ExitIntentModal 
              isOpen={showExitIntent} 
              onClose={hideExitIntent} 
            />
          )}
        </AppProvider>
      </Router>
    </HelmetProvider>
  );
}

function App() {
  return (
    <PayPalScriptProvider 
      options={paypalOptions} 
      deferLoading={false}
    >
      <AppContent />
    </PayPalScriptProvider>
  );
}

export default App;
